export type AgentSourceId =
  | 'serato'
  | 'virtualdj'
  | 'spotify'
  | 'tidal'
  | 'apple';

export const AGENT_SOURCE_IDS: AgentSourceId[] = [
  'serato',
  'virtualdj',
  'spotify',
  'tidal',
  'apple',
];

export const defaultAgentSourceIncludes = (): Record<
  AgentSourceId,
  boolean
> => ({
  serato: true,
  virtualdj: true,
  spotify: true,
  tidal: true,
  apple: true,
});
